// Single source of truth for the unauthenticated public-route prefix. Lives in a
// zero-dependency flat module so the identity-gate guards (app-loading,
// auth-provider, the useUserSettings query) can all import the same constant
// without creating an import cycle between the app shell and the who-am-i lib.
//
// Every guard that bypasses the authenticated app for the public form keys off
// `window.location.pathname.startsWith(PUBLIC_PATH_PREFIX)`. Keeping the literal
// here makes the bypass greppable and prevents the prefix from drifting between
// guards.
export const PUBLIC_PATH_PREFIX = '/public/';
